import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthenticationInterceptor } from './authentication.interceptor';
import { AuthenticatorService } from 'idk/services/security/authenticator.service';

@NgModule({
    imports  : [
        HttpClientModule
    ],
    providers: [
        AuthenticatorService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptor,
            multi   : true
        }
    ]
})
export class AuthModule
{
}
